import AWS from "aws-sdk";
import async from "async";
import JSZip from "jszip";

const accessKey = process.env.REACT_APP_AWS_ACCESSKEY_ID;
const accessSecret = process.env.REACT_APP_AWS_ACCESSKEY_SECRET;
const region = process.env.REACT_APP_AWS_REGION;
const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;

const s3 = new AWS.S3({
  accessKeyId: accessKey,
  secretAccessKey: accessSecret,
  region: region,
});

function s3ZipDownload(prefix, path, zipName, zipCallback) {
  const zip = new JSZip();
  const params = {
    Bucket: bucketName,
    Prefix: prefix,
  };
  s3.listObjects(params, function (err, data) {
    if (err) return console.log(err);
    async.eachSeries(
      data.Contents,
      function (fileObj, callback) {
        if (fileObj.Key.split(".")[1] !== "zip") {
          const key = fileObj.Key;
          const fileName = key.split("/")[key.split("/").length - 1];

          const fileParams = {
            Bucket: bucketName,
            Key: key,
          };

          s3.getObject(fileParams, function (err, fileContents) {
            if (err) {
              callback(err);
            } else {
              // Read the file
              const contents = fileContents.Body;
              // console.log(contents)
              zip.file(fileName, contents, { base64: true });
              // fs.writeFileSync(__dirname+"/"+key,contents); // 저장하기
              // Do something with file

              callback();
            }
          });
        } else {callback()}
      },
      function (err) {
        if (err) {
          console.log("Failed: " + err);
        } else {
          zip.generateAsync({ type: "blob" }).then((content) => {
            const params = {
              Bucket: bucketName,
              Key: path + zipName + ".zip", // 폴더가 없으면 만들어서 넣는다.
              Body: content,
              //   ContentType: fileContent.type
            };
            s3.upload(params, zipCallback);
          });
          console.log("Finished");
        }
      }
    );
  });
}

export default s3ZipDownload;
